import React from "react";
import { Redirect } from "react-router-dom";
import { useAppSelector } from "types/hooks";
import { selectUserRole } from "store/authSelectors";
import { isSysadminRole } from "helpers/roleUtils";
import ContentAreaLoadingFallback from "../common/ContentAreaLoadingFallback";

export default function HomeRedirect() {
  const role = useAppSelector(selectUserRole);
  const isAuthed = useAppSelector((s) => !!(s.auth?.user?.key || s.auth?.deviceToken));
  const awaitingRole = isAuthed && role === null;

  if (awaitingRole) {
    return <ContentAreaLoadingFallback />;
  }

  if (isSysadminRole(role)) {
    return <Redirect to="/businesses" />;
  }

  return <Redirect to="/search" />;
}
